// The StripeElements library shows the following disclaimer when rendering the payment form: 'By
// providing your card information, you allow **company-name** to charge your card for future
// payments in accordance with their terms.'
//
// This is controlled by the `terms` object in the API. We want to disable all disclaimers for all
// payment methods in Stripe.
//
// List taken from https://stripe.com/docs/js/elements_object/create_payment_element#payment_element_create-options-terms
export const terms = {
  applePay: 'never',
  auBecsDebit: 'never',
  bancontact: 'never',
  card: 'never',
  cashapp: 'never',
  googlePay: 'never',
  ideal: 'never',
  // Not in the docs; accepted by @stripe/stripe-js 9.16 TermsOption.
  klarna: 'never',
  paypal: 'never',
  sepaDebit: 'never',
  sofort: 'never',
  usBankAccount: 'never',
}

// Kept for a later charge, these carry a debit mandate Stripe must show.
export const mandateTerms = [
  'auBecsDebit',
  'bancontact',
  'ideal',
  'sepaDebit',
  'sofort',
  'usBankAccount',
]

export function termsFor(automaticPaymentMethods, futureCharge) {
  if (!automaticPaymentMethods || !futureCharge) return terms

  return Object.fromEntries(
    Object.entries(terms).filter(([type]) => !mandateTerms.includes(type))
  )
}
